import React from 'react'
import XTwitter from '@v4/components/common/FAIcons/Brands/XTwitter'

export const CONTENT_VARIANTS = Object.freeze({
	VARIANT_1: 'content-1',
	VARIANT_2: 'content-2',
	VARIANT_3: 'content-3',
	VARIANT_4: 'content-4',
	VARIANT_5: 'content-5',
	VARIANT_6: 'content-6',
	VARIANT_7: 'content-7',
	VARIANT_8: 'content-8',
})

export const SHARED_LINKS = [
	{
		key: 'show_facebook_link',
		href: `http://www.facebook.com/sharer.php?u=${window.initialData.scorecard_url}`,
		icon: 'fab fa-facebook-f',
	},
	{
		key: 'show_twitter_link',
		href: `http://twitter.com/share?url=${window.initialData.scorecard_url}`,
		icon: <XTwitter />,
	},
	{
		key: 'show_linkedin_link',
		href: `https://www.linkedin.com/shareArticle?mini=true&url=${window.initialData.scorecard_url}`,
		icon: 'fab fa-linkedin-in',
	},
]
